import { createAction, props } from '@ngrx/store';

export const sendAgreementForSignatures = createAction(
  '[Session] Send Agreement For Signatures',
  props<{ groupId: string; email: string }>(),
);

export const sendAgreementForSignaturesSuccess = createAction(
  '[Session] Send Agreement For Signatures Success',
  props<{ groupId: string }>(),
);

export const sendAgreementForSignaturesFailure = createAction(
  '[Session] Send Agreement For Signatures Failure',
  props<{ error: any }>(),
);
